import { useState, useLayoutEffect } from 'react';

import { useIsMounted } from '@sportsbook/common/hooks/use-is-mounted';

export const useContainerQueryUp = (ref, breakpoint) => {
  const [isLargerThanBreakpoint, setIsLargerThanBreakpoint] = useState(false);
  const isMounted = useIsMounted();

  useLayoutEffect(() => {
    if (!isMounted) return () => {};

    const observer = new ResizeObserver(([entry]) => {
      setIsLargerThanBreakpoint(entry.contentRect.width >= breakpoint);
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref, breakpoint, isMounted]);

  return isLargerThanBreakpoint;
};
